import { render } from "./Footer.vue?vue&type=template&id=0c4a3fec"
const script = {}

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__